{
  "title": "Raulothim's Psychic Lance",
  "source": "Fizban's Treasury of Dragons",
  "levelAndSchool": "4th-level Enchantment",
  "level": 4,
  "castingTime": "1 action",
  "range": "120 feet",
  "components": "V",
  "duration": "Instantaneous",
  "description": [
    "You unleash a shimmering lance of psychic power from your forehead at a creature that you can see within range. Alternatively, you can utter a creature’s name. If the named target is within range, it becomes the spell’s target even if you can’t see it. If the named target isn’t within range, the lance dissipates without effect.",
    "The target must make an Intelligence saving throw. On a failed save, the target takes 7d6 psychic damage and is incapacitated until the start of your next turn. On a successful save, the creature takes half as much damage and isn’t incapacitated.",
    "At Higher Levels. When you cast this spell using a spell slot of 5th level or higher, the damage increases by 1d6 for each slot level above 4th."
  ],
  "spellLists": ["bard", "arcane-trickster", "sorcerer", "warlock", "wizard"]
}
